import { render, staticRenderFns } from "./regConfirmation.vue?vue&type=template&id=26c486e6&scoped=true"
import script from "./regConfirmation.vue?vue&type=script&lang=js"
export * from "./regConfirmation.vue?vue&type=script&lang=js"
import style0 from "./regConfirmation.vue?vue&type=style&index=0&id=26c486e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26c486e6",
  null
  
)

export default component.exports